module.exports = __webpack_public_path__ + "f8ec670240a1736da8989374a472fa43.pdf";